<template>
  <b-card>
    <b-row align-h="between">
      <b-col>
        <h4>Investissements</h4>
      </b-col>
      <b-col cols="1" class="text-right">
        <b-avatar
          size="32"
          variant="light-primary"
          v-b-tooltip.hover.v-primary
          title="Cet indicateur compare la part des ventes à des investisseurs et à des occupants en volume et en pourcentage sur les 4 dernières années sur le secteur du programme ou adresse sélectionné."
        >
          <feather-icon size="20" icon="HelpCircleIcon" />
        </b-avatar>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="8">
        <sales-invest-chart :ventesByPeriode="reportData.ventesByPeriode[0]" />
      </b-col>
      <b-col xl="4">
        <sales-invest-array :ventesByPeriode="reportData.ventesByPeriode[0]" />
      </b-col>
      <b-col xl="12">
        <comment-form-text-area
          :enable="reportData.comments.salesInvest.enable"
          :commentField="reportData.comments.salesInvest.value"
          v-on:update:comment="reportData.comments.salesInvest.value = $event"
          v-on:update:enable="reportData.comments.salesInvest.enable = $event"
          v-on="$listeners"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BCard, BRow, BCol, VBTooltip, BAvatar } from "bootstrap-vue";
import SalesInvestChart from "./sales-invest-elements/SalesInvestChart";
import SalesInvestArray from "./sales-invest-elements/SalesInvestArray";
import CommentFormTextArea from "../../shared/CommentFormTextArea";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BAvatar,

    SalesInvestArray,
    SalesInvestChart,
    CommentFormTextArea,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  props: {
    reportData: {
      type: Object,
      required: true,
    },
  },
};
</script>
